import { render, staticRenderFns } from "./CheckOrd.vue?vue&type=template&id=68f6f3f7"
import script from "./CheckOrd.vue?vue&type=script&lang=js"
export * from "./CheckOrd.vue?vue&type=script&lang=js"
import style0 from "./CheckOrd.vue?vue&type=style&index=0&id=68f6f3f7&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68f6f3f7')) {
      api.createRecord('68f6f3f7', component.options)
    } else {
      api.reload('68f6f3f7', component.options)
    }
    module.hot.accept("./CheckOrd.vue?vue&type=template&id=68f6f3f7", function () {
      api.rerender('68f6f3f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inventory/CheckOrd.vue"
export default component.exports